/// <reference path="../../../../../rcwebmodels/geofencemodel.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GridToolBarControl } from '../sharedcomponents/GridToolBarControl';
import { RCUtils } from './../../RCUtils';
import GeofenceMap from '../../actions/GeofenceMap';
import Formatters from '../../actions/Formatters';
import { CellRenderer } from '../../actions/CellRenderer';
import * as Autosuggest from 'react-autosuggest';
import $ from 'jquery';
import * as Exceljs from '../../actions/ExportToExcel.js';
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
//import '../../../node_modules/react-datetime-bootstrap/css/bootstrap-datetimepicker.min.css';

var Excel = Exceljs.default;
var Config: any = require('../../Config.json');
var self;
var geofencData;
var checkRight: any;
export interface GeofenceGridState {
    rowData: server.GetGeofenceCoordinates[];
    columnDefs: any[];
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;
    emailHtml: any;
    suggestionsFenceId: any[],
    targetId: string,
    fenceIdValue: any,
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
}

export class GeofenceGrid extends React.Component<any, GeofenceGridState> {
    constructor(props: any) {
        super(props);
        var columnDefs = this.createColumnDefs();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        checkRight = false;
        this.state = {
            rowData: [],
            columnDefs: columnDefs,
            overlayLoadingTemplate: overlayTemplate,
            pageSize: 25,
            gridApiParams: [],
            emailHtml: '',
            suggestionsFenceId: [],
            targetId: '',
            fenceIdValue: '',
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 }
        };

        self = this;
    }

    updatemGeofenceGridDimensions() {
        $(".Geofence_Grid").css('min-height', $(window).height() - 187);
        $(".Geofence_Grid").css('height', $(window).height() - 187);
        $(".Geofence_Grid").css('max-height', $(window).height() - 187);
    }


    componentDidMount() {
        this.updatemGeofenceGridDimensions();
        window.addEventListener("resize", this.updatemGeofenceGridDimensions.bind(this));

       
       
        
        
    }

    componentWillReceiveProps(nextprops: any) {
        geofencData = [];
        var geofenceData = nextprops.geofenceData;
        if (geofenceData != undefined && geofenceData != null) {
            this.setState({ rowData: geofenceData });
            geofencData.push(nextprops.fenceIdArray);
        }
    }

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: "Fence ID", field: "Tag", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Tag"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 140
            },
            {
                headerName: "Fence name", field: "Name", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Name"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 120
            },
            {
                headerName: "Address", field: "Address", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Address"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 200
            },
            {
                headerName: "Geofence type", field: "GeofenceCategoryCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.GeofenceCategoryCd); },
                filterParams: { valueGetter: params => { return Formatters.GeofenceTypeFormatterForFilter(params); } },
                cellRenderer: Formatters.fenceTypeFormatter, width: 120
            },
            {
                headerName: "Geofence revision", field: "GeofenceRevisionNum", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "GeofenceRevisionNum"); },
                cellRenderer: CellRenderer.StringTypeValueFormatter, width: 120
            },
            {
                headerName: "Coordinates", field: "Coordinates", cellClass: 'myExcelStyle', resizable: true,
                cellRenderer: Formatters.GeofenceCoordinatesFormatter, width: 200
            }
        ];
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
        //alert(this.state.pageSize);
    }

    onGridSelectionChanged(params: any) {
        if (!checkRight) {
            var authRight = RCUtils.CheckAssesRightsOnly('146');
            if (authRight)
                checkRight = true;
        }
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            if (checkRight)
                setTimeout(() => { GeofenceMap.ShowSelectedGeofence(selectedRow) }, 1000);
            //GeofenceMap.ShowSelectedGeofence(selectedRow);
        });
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    refreshGeofenceManagementGrid() {
        this.setState({ fenceIdValue: '' }, () => { this.props.geofenceSearchbyFenceName(this.state.fenceIdValue, this.state.gridApiParams) });
    }

    geofenceSearchbyFenceId() {
        this.props.geofenceSearchbyFenceName(this.state.fenceIdValue, this.state.gridApiParams);
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };

    getFenceNameSuggestions(value) {
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofencData[0].filter(tag =>
            //tag.toLowerCase().slice(0, inputLength) === inputValue
            tag.toLowerCase().includes(inputValue)//RCNG-279
        );
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };

    onChangeFenceId = (event, { newValue }) => {
        this.setState({
            fenceIdValue: newValue,
            targetId: event.target.id
        });
    };

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }

    static handleClearFenceId() {
        self.setState({
            fenceIdValue: '',
        });
    }

    groupRowInnerRenderer(params) {

        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        /* Start RCNG-197 var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        var columnDisplayName = colDef[0].colDef.headerName;  End RCNG-197*/
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName; //RCNG - 197

        if (fieldValue == "-NA-")
            return "*No " + columnDisplayName;

        if (fieldName.toString().trim() == "GeofenceCategoryCd")
            return Formatters.GeofenceTypeGrouping(fieldValue);

        //if (fieldName.toString().trim() == "Coordinates")
        //    return Formatters.GeofenceCoordinatesGrouping(fieldValue);               

        return fieldValue;

    }


    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];

        const { suggestionsFenceId } = this.state;

        const FenceIdListinputProps = {
            id: 'fenceSearch',
            placeholder: 'Fence Search',
            value: this.state.fenceIdValue,
            onChange: this.onChangeFenceId.bind(this)
        };

        return <div>
            <div className='hstack gap-2'>
                <GridToolBarControl refreshGrid={this.refreshGeofenceManagementGrid.bind(this)} gridData={this.state.rowData} colDefs={this.state.columnDefs}
                    isIncludeRowGroup={this.state.gridApiParams.gridOptionsWrapper == undefined
                        && this.state.gridApiParams.gridOptionsWrapper == null ? false :
                        this.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false}
                    gridApiParams={this.state.gridApiParams}
                    parentchild={"P"} formName={"GeofenceManagement"} />
                <div className='input-group fence-search ms-auto'>
                  <Autosuggest name="fenceSearch" id="fenceSearch"
                        suggestions={suggestionsFenceId}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        inputProps={FenceIdListinputProps}
                        highlightFirstSuggestion={true}
                    />
                        <button type="button" className="btn btn-primary" onClick={this.geofenceSearchbyFenceId.bind(this)}> Search </button>                   
                </div>
            </div>
            <div className="ag-theme-fresh Geofence_Grid">
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    animateRows={true}
                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    pagination={true}
                    groupRowRendererParams={groupRowRendererParams}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                    defaultGroupOrderComparator={
                        function (nodeA, nodeB) {
                            var AnodeIsNumber = Number(nodeA.key);
                            var BnodeIsNumber = Number(nodeB.key);
                            var AnodeIsString = String(nodeA.key);
                            var BnodeIsString = String(nodeB.key);

                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                return AnodeIsNumber - BnodeIsNumber;
                            } else {
                                return AnodeIsString.localeCompare(BnodeIsString);
                            }
                        }
                    }
                    groupDisplayType='groupRows'
                    excelStyles={excelStyles}
                    paginationPageSize={this.state.pageSize}
                    rowSelection={'single'}
                    accentedSort={true}
                    onSelectionChanged={this.onGridSelectionChanged}
                    onPaginationChanged={this.onPaginationPageLoaded}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}>
                </AgGridReact>
            </div>
            <div className='geofence-pagesize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>;
    }
}